import req from './api'

// === Email login ===
export const apiEmailLogin = (data) => req("post", "/auth3/login/", data);

// === Logout ===
export const apiLogout = () => req("post", "/auth3/logout/")
